import { hasClaimDetailValue } from './hasClaimDetailValue';

export const CLAIM_PAYEE_TITLE = 'Check Payee';

export const CLAIM_PAYEE_FOOTNOTE = 'As entered on the claim form. Does not confirm who was paid.';

export function getClaimPayeeDisplayName(value) {
  if (!hasClaimDetailValue(value)) return null;
  return String(value).trim();
}

export function formatClaimPayeeForShare({ claimName, accountName, payeeName }) {
  const payee = getClaimPayeeDisplayName(payeeName);
  if (!payee) return null;

  const lines = [
    claimName ? `Claim ${claimName}` : null,
    accountName ? `Account: ${accountName}` : null,
    `Check payee (as entered on claim form): ${payee}`,
    'Note: This reflects what the property entered when filing the claim and does not confirm who received payment.',
  ].filter(Boolean);

  return lines.join('\n');
}
